<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="selectField" />

    <!-- 수행평가 대상 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 수행평가 대상</h5>

      <div class="writeGridContainer">
        <div>
          <div>부서(업체)명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <company-selector v-else v-model="form.inputA_1" :comName="form.com_name" :fieldId="form.stdInfo.field_id" :readonly="board.readonly || !form.stdInfo.field_id" @select="onSelectFieldSelector" />
        </div>
        <div>
          <div>피평가자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" :readonly="board.readonly" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_6 }}</p>
          <date-selector v-model="form.inputA_6" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 업무 수행 여부 -->
<!--    <div class="mt-28px">-->
<!--      <table class="w-full task-completed" >-->
<!--        <colgroup>-->
<!--          <col width="160" />-->
<!--          <col width="" />-->
<!--          <col width="82" />-->
<!--          <col width="82" />-->
<!--          <col width="82" />-->
<!--          <col width="200" />-->
<!--          <col width="200" />-->
<!--        </colgroup>-->
<!--        <tr>-->
<!--          <th>관계법령</th>-->
<!--          <th>평가항목</th>-->
<!--          <th>적정</th>-->
<!--          <th>미흡</th>-->
<!--          <th>해당없음</th>-->
<!--          <th>향후 개선계획</th>-->
<!--          <th>비고</th>-->
<!--        </tr>-->

<!--        <tr v-for="(row, rowIndex) in form.inspectList">-->
<!--          <th class="whitespace-pre">{{row.title}}</th>-->
<!--          <th class="text-left"><span class="mr-2">{{rowIndex + 1}}.</span>{{row.label}}</th>-->
<!--          <td>-->
<!--            <div class="flex items-center justify-center">-->
<!--              <PrintCheckbox v-if="isPrint" label="" :value="row.is_checked === 2" color style="width: fit-content" class="mx-auto" />-->
<!--              <vs-checkbox v-else :disabled="board.readonly"-->
<!--                           :checked="row.is_checked === 2"-->
<!--                           @change="row.is_checked = row.is_checked === 2 ? -1 : 2"/>-->
<!--            </div>-->
<!--          </td>-->
<!--          <td>-->
<!--            <div class="flex items-center justify-center">-->
<!--              <PrintCheckbox v-if="isPrint" label="" :value="row.is_checked === 1" color style="width: fit-content" class="mx-auto" />-->
<!--              <vs-checkbox v-else :disabled="board.readonly"-->
<!--                           :checked="row.is_checked === 1"-->
<!--                           @change="row.is_checked = row.is_checked === 1 ? -1 : 1"/>-->
<!--            </div>-->
<!--          </td>-->
<!--          <td>-->
<!--            <div class="flex items-center justify-center">-->
<!--              <PrintCheckbox v-if="isPrint" label="" :value="row.is_checked === 0" color style="width: fit-content" class="mx-auto" />-->
<!--              <vs-checkbox v-else :disabled="board.readonly"-->
<!--                           :checked="row.is_checked === 0"-->
<!--                           @change="row.is_checked = row.is_checked === 0 ? -1 : 0"/>-->
<!--            </div>-->
<!--          </td>-->
<!--          <td>-->
<!--            <p v-if="isPrint" class="print-input">{{ row.plan }}</p>-->
<!--            <ml-input v-else v-model="row.plan" :readonly="board.readonly" />-->
<!--          </td>-->
<!--          <td>-->
<!--            <p v-if="isPrint" class="print-input">{{ row.note }}</p>-->
<!--            <ml-input v-else v-model="row.note" :readonly="board.readonly" />-->
<!--          </td>-->
<!--        </tr>-->
<!--      </table>-->
<!--    </div>-->

    <!--    청소(미화)-->
    <table-inspect-performance-evaluation
      class="mt-28px"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      title="업무 수행 여부"
      v-model="form.inspectList"
      :is-header-column1="false"
      :is-note="true"
      :is-note2="true"
      table-header-column2="관계법령"
      table-header-title="평가항목"
      table-header-yes="적정"
      table-header-no="미흡"
      table-header-na="해당없음"
      table-header-note="향후 개선계획"
      table-header-note2="비고"
      @update-list-check="updateListCheck"
      @update-note="updateListNote"
    />

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="form.photoList.length"
      @add="handleAddPhotoList"
      @remove="handleRemovePhotoList"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
      class="mt-28px"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectPerformanceEvaluation from "@/components/TableInspectPerformanceEvaluation.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import DateSelector from "@/components/selector/DateSelector";
import FieldSelector from "@/components/selector/FieldSelector";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SignField from "@/components/SignField.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    PrintCheckbox,
    SignField,
    CompanySelector,
    FieldSelector,
    DateSelector,
    PhotoUploadGridModule,
    TableInspectPerformanceEvaluation,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        com_name: '',
        stdInfo: {},
        fileList: [],
        writer: {
          name: "",
          sign: "",
        },
        checker: {
          name: "",
          sign: "",
        },
        photoList: [
          { id: 0, fileName: "", fileSize: 0, path: "", thumb: "", input: "", placeholder: "조치 전", check: false },
          { id: 1, fileName: "", fileSize: 0, path: "", thumb: "", input: "", placeholder: "조치 전", check: false },
        ],
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",

        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
        sign4: { name: "", sign: "" },

        inspectList: [
          {
            id: 1,
            col2: "산안법시행령<br/>제15조제1호",
            label: "1. 사업장 내 기계·기구 또는 설비의 안전보건 점검 및 이상 유무 확인",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 2,
            col2: "산안법시행령<br/>제15조제2호",
            label: "2. 근로자의 작업복·보호구 및 방호장치의 점검과 그 착용·사용에 관한 교육·지도",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 3,
            col2: "산안법시행령<br/>제15조제3호",
            label: "3. 산업재해에 관한 보고 및 이에 대한 응급조치",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 4,
            col2: "산안법시행령<br/>제15조제4호",
            label: "4. 작업장 정리·정돈 및 통로 확보에 대한 확인·감독",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 5,
            col2: "산안법시행령<br/>제15조제5호",
            label: "5. 사업장 안전관리자, 보건관리자, 산업보건의의 지도·조언에 대한 협조",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 6,
            col2: "산안법시행령<br/>제15조제6호",
            label: "6. 위험성평가 실시에 따른 유해·위험요인의 파악 및 개선조치 시행에 대한 참여",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
        ],
      },
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.com_name = value.com_name;
      this.$emit("selectField", value);
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
    updateListNote(indexRows, text) {
      this.form.inspectList[indexRows].note = text;
    },
    handleAddPhotoList() {
      this.form.photoList.push({ id: 0, fileName: "", fileSize: 0, path: "", thumb: "", input: "", placeholder: "조치 전", check: false });
    },
    handleRemovePhotoList() {
      for (let i = this.form.photoList.length - 1; i >= 0; i--) {
        if (this.form.photoList[i].check) {
          this.form.photoList.splice(i, 1);
        }
      }
    },
    selectField() {
      this.form.inputA_1 = "";
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}

.task-completed {
  border-collapse: collapse;
  border-spacing: 0;
  border-left: 1px solid #cdcdcd;
  border-top: 1px solid #cdcdcd;

  th, td {
    font-size: 14px;
    padding: 14px;

    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  th {
    text-align: center;
  }
  td {
    text-align: start;
  }
}
</style>
